import ApiService from '../services/ApiService';

export default class NewsletterReportRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    getNewsletterReport() {
        return this.apiService.get('newsletter-report/export', {
            responseType: 'blob'
        });
    }
}
